import React from 'react';
import { FadeIn } from './FadeIn';
import { Lightbulb, ShieldCheck, Smile, Compass, TrendingUp } from 'lucide-react';
export function Results() {
  const results = [{
    icon: <Lightbulb size={28} data-id="element-172" />,
    text: 'tener ideas claras para desayunos, almuerzos, cenas y snacks'
  }, {
    icon: <ShieldCheck size={28} data-id="element-173" />,
    text: 'reducir el caos de “no sé qué comer”'
  }, {
    icon: <Smile size={28} data-id="element-174" />,
    text: 'disfrutar más tus comidas sin tanta culpa'
  }, {
    icon: <Compass size={28} data-id="element-175" />,
    text: 'moverte con más seguridad en restaurantes y eventos'
  }, {
    icon: <TrendingUp size={28} data-id="element-176" />,
    text: 'sostener un enfoque más realista a largo plazo'
  }];
  return <section className="py-24 bg-cream" data-id="element-177">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-178">
        <FadeIn data-id="element-179">
          <div className="text-center mb-16" data-id="element-180">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-warm-brown mb-6" data-id="element-181">
              Lo que vas a conseguir
            </h2>
            <p className="text-xl text-gray-600" data-id="element-182">Con este PDF vas a poder:</p>
          </div>
        </FadeIn>

        <div className="space-y-6" data-id="element-183">
          {results.map((result, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-184">
              <div className="bg-white rounded-2xl p-6 flex items-center shadow-sm hover:shadow-md transition-shadow border border-warm-beige" data-id="element-185">
                <div className="bg-warm-beige/50 text-warm-brown p-4 rounded-xl mr-6 shrink-0" data-id="element-186">
                  {result.icon}
                </div>
                <p className="text-lg md:text-xl font-medium text-gray-800" data-id="element-187">
                  {result.text}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}